var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVegetationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icone_v\xE9g\xE9tation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exports",
    transform: "translate(-161.000000, -386.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.85745,392.981293 C176.187755,393.012931 175.681791,392.810772 175.110011,392.650574 C174.507237,392.481984 174.146222,392.285995 173.832732,393.012931 C173.497398,393.789975 174.200625,398.166587 174.831442,398.280626 C176.27934,398.542274 177.531529,399.107038 178.72527,399.806081 C179.301772,400.143508 179.708837,400.506853 179.262512,401.085933 C178.801428,401.683773 175.87845,402 172.711607,402 C170.353317,402 166.681886,401.658349 166.219031,401.048414 C165.761489,400.445637 166.331497,400.08871 166.849257,399.777448 C168.031486,399.06705 169.329724,398.566217 170.746037,398.248784 C171.407259,398.100435 171.839621,393.691981 171.419863,392.875443 C171.070656,392.1959 170.624036,392.057917 169.849757,392.344496 C166.327866,393.64755 163.593538,392.513332 161.849271,389.534746 C160.392222,387.047612 160.66409,386.709198 163.812568,386.165168 C168.251018,385.397998 171.168363,387.366526 171.595205,390.757825 C171.678448,391.419596 171.997251,392.062361 172.711607,392.037677 C173.373124,392.014721 173.68927,391.291241 173.645287,390.709692 C173.388769,387.324564 178.139528,385.766279 181.318115,386.678343 C182.100363,386.902718 182.389058,387.211265 182.201023,388.014721 C181.717209,390.081737 180.850241,391.83527 178.30749,392.701916 C177.999904,392.80674 177.516557,392.899865 176.85745,392.981293 Z",
    id: "icone_v\\xE9g\\xE9tation"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetationIcon);
export default __webpack_public_path__ + "static/media/vegetationIcon.5093c597.svg";
export { ForwardRef as ReactComponent };